var _path, _g, _path2, _g2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5288_1312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 35,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.835938 11.6582H34.1686V34.5649H0.835938V11.6582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5288_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7776 34.5649H8.2276C4.1526 34.5649 0.835938 31.2499 0.835938 27.1732V19.0482C0.835938 14.9732 4.1526 11.6582 8.2276 11.6582H9.7826C10.4726 11.6582 11.0326 12.2182 11.0326 12.9082C11.0326 13.5982 10.4726 14.1582 9.7826 14.1582H8.2276C5.52927 14.1582 3.33594 16.3515 3.33594 19.0482V27.1732C3.33594 29.8715 5.52927 32.0649 8.2276 32.0649H26.7776C29.4743 32.0649 31.6693 29.8715 31.6693 27.1732V19.0332C31.6693 16.3449 29.4826 14.1582 26.7959 14.1582H25.2243C24.5343 14.1582 23.9743 13.5982 23.9743 12.9082C23.9743 12.2182 24.5343 11.6582 25.2243 11.6582H26.7959C30.8609 11.6582 34.1693 14.9665 34.1693 19.0332V27.1732C34.1693 31.2499 30.8526 34.5649 26.7776 34.5649Z",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5288_1312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 3,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 0.333984H18.75V22.9022H16.25V0.333984Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5288_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 22.9023C16.81 22.9023 16.25 22.3423 16.25 21.6523V1.58398C16.25 0.893984 16.81 0.333984 17.5 0.333984C18.19 0.333984 18.75 0.893984 18.75 1.58398V21.6523C18.75 22.3423 18.19 22.9023 17.5 22.9023Z",
    fill: "#707070"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6441 7.71503C12.3258 7.71503 12.0058 7.59336 11.7625 7.35003C11.2741 6.86336 11.2708 6.07336 11.7591 5.58336L16.6175 0.703359C17.0858 0.231693 17.9191 0.231693 18.3875 0.703359L23.2475 5.58336C23.7341 6.07336 23.7325 6.86336 23.2441 7.35003C22.7541 7.83669 21.9641 7.83669 21.4775 7.34669L17.5025 3.35669L13.5291 7.34669C13.2858 7.59336 12.9641 7.71503 12.6441 7.71503Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.93e1ab88c795abf7e9af9252900fc4b3.svg";
export { ForwardRef as ReactComponent };